import React,{useState, useEffect} from 'react';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';

import DateSelectorNanoox from "./utils/DateSelectorNanoox";

import {generateReport} from "../../../../services/api"


const ModalStyle = {
    position: 'absolute',
    marginTop: '28vh',
    marginLeft: '29vw',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#282828',
    borderRadius: '1vw',
    // border: '1px solid',
    width:'47vw',
    height:'49vh'
};

function ModalCalendario({  servidor, openModal, setOpenModal, idioma, translate }) {

  // -- Descargar Reportes -- //
  const [cargando, setCargando] = useState(false);
  // -- Notificaciones -- //
  const [notificationOpen, setNotification_open] = useState(false);
  const [notificationMsg, setNotification_msg] = useState('');
  const [notificationStatus, setNotification_status] = useState('info'); 
  // 'success' | 'error' | 'warning' | 'info'

// console.log('controlType',controlType)
 const makeReport = async (startDate, endDate, reportType) => {
  setCargando(true)
    // Obtener credenciales del cliente
    let region, area, centro;
    try {
        region = localStorage.getItem('REGION');
        area = localStorage.getItem('AREA');
        centro = localStorage.getItem('CENTRO');
    } catch {
        region = null;
        area = null;
        centro = null;
    }


    console.log('Solicitando reporte de: ', startDate, endDate, 'Tipo de reporte: ', reportType);
    console.log("%c Solicitando reporte de: ", "color: green; font-size: 50px",startDate, endDate, 'Tipo de reporte: ', reportType );
    
    const result = await generateReport(servidor, startDate, endDate);

    if (result?.error) {
      setNotification_msg(result.message || translate('report_generation_error'));
      setNotification_status('error');
      setNotification_open(true);
    } else {
      setNotification_msg(translate('report_downloaded_successfully'));
      setNotification_status('success');
      setNotification_open(true);
    }

    setCargando(false);


};

useEffect(() => {
    if (notificationOpen) {
      const timer = setTimeout(() => {
        setNotification_open(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [notificationOpen]);


  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots(prev => prev.length < 3 ? prev + '.' : '');
    }, 500); // cada 500ms se añade un punto

    return () => clearInterval(interval); // limpiar el intervalo al desmontar
  }, []);
    

    return (
        <>
          {cargando && 
            <Alert variant="filled" severity="info" 
            style={{position:'absolute',  zIndex:55, marginLeft: "38vw", fontSize: '1vw', alignContent: 'center', alignItems:'center',overflow:'hidden', 
            justifyContent: "center", cursor: 'default !important', userSelect: 'none'}}>
              {translate('generating_report')} {dots}
            </Alert>
          }
            {openModal && // Asegura que el componente se desmonte por completo
                (/* Modal Fechas */
                    < Modal
                        open={openModal}
                        onClose={() => setOpenModal(false)}
                    >
                        <Box style={ModalStyle} >
                            <DateSelectorNanoox  makeReport={makeReport} closeModal={() => setOpenModal(false)} idioma={idioma} translate={translate} setNotification_open={setNotification_open} setNotification_msg={setNotification_msg} setNotification_status={setNotification_status} />
                        </Box>
                    </Modal >
                )
            }
        </>
    );
}

export default ModalCalendario;
